module.exports = __webpack_public_path__ + "static/media/product-UTStamp.97579eaa.png";